export default __webpack_public_path__ + "static/media/whatsapp.dd557170.svg";